// Drawer Actions
export const DRAWER_TOGGLE = 'DRAWER_TOGGLE'
export const DRAWER_COLLAPSE = 'DRAWER_COLLAPSE'

// Auth Actions
export const LOGIN_BEGIN = 'LOGIN_BEGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'

export const AUTO_LOGIN_BEGIN = 'AUTO_LOGIN_BEGIN'
export const AUTO_LOGIN_SUCCESS = 'AUTO_LOGIN_SUCCESS'
export const AUTO_LOGIN_FAILURE = 'AUTO_LOGIN_FAILURE'

export const VERIFY_AUTH_COOKIE_BEGIN = 'VERIFY_AUTH_COOKIE_BEGIN'
export const VERIFY_AUTH_COOKIE_SUCCESS = 'VERIFY_AUTH_COOKIE_SUCCESS'
export const VERIFY_AUTH_COOKIE_FAILURE = 'VERIFY_AUTH_COOKIE_FAILURE'

export const RECONNECT_BEGIN = 'RECONNECT_BEGIN'
export const RECONNECT_SUCCESS = 'RECONNECT_SUCCESS'
export const RECONNECT_FAILURE = 'RECONNECT_FAILURE'

export const SET_DISCONNECT = 'SET_DISCONNECT'

export const LOGOUT_BEGIN = 'LOGOUT_BEGIN'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'

export const RECOVERY_PASSWORD_BEGIN = 'RECOVERY_PASSWORD_BEGIN'
export const RECOVERY_PASSWORD_SUCCESS = 'RECOVERY_PASSWORD_SUCCESS'
export const RECOVERY_PASSWORD_FAILURE = 'RECOVERY_PASSWORD_FAILURE'

export const RESET_PASSWORD_BEGIN = 'RESET_PASSWORD_BEGIN'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'

export const SET_DARK_MODE = 'SET_DARK_MODE'

// Customer Actions
export const GET_CUSTOMER_BEGIN = 'GET_CUSTOMER_BEGIN'
export const GET_CUSTOMER_SUCCESS = 'GET_CUSTOMER_SUCCESS'
export const GET_CUSTOMER_FAILURE = 'GET_CUSTOMER_FAILURE'

export const SET_COMPLETE_REGISTER_DATA = 'SET_COMPLETE_REGISTER_DATA'

export const COMPLETE_REGISTER_BEGIN = 'COMPLETE_REGISTER_BEGIN'
export const COMPLETE_REGISTER_SUCCESS = 'COMPLETE_REGISTER_SUCCESS'
export const COMPLETE_REGISTER_FAILURE = 'COMPLETE_REGISTER_FAILURE'

// Bypass Customer Actions
export const GET_ALL_BYPASS_CUSTOMERS_BEGIN = 'GET_ALL_BYPASS_CUSTOMERS_BEGIN'
export const GET_ALL_BYPASS_CUSTOMERS_SUCCESS = 'GET_ALL_BYPASS_CUSTOMERS_SUCCESS'
export const GET_ALL_BYPASS_CUSTOMERS_FAILURE = 'GET_ALL_BYPASS_CUSTOMERS_FAILURE'

export const SET_BYPASS_CUSTOMERS_QUERY = 'SET_BYPASS_CUSTOMERS_QUERY'

export const GET_BYPASS_CUSTOMER_BEGIN = 'GET_BYPASS_CUSTOMER_BEGIN'
export const GET_BYPASS_CUSTOMER_SUCCESS = 'GET_BYPASS_CUSTOMER_SUCCESS'
export const GET_BYPASS_CUSTOMER_FAILURE = 'GET_BYPASS_CUSTOMER_FAILURE'

export const POST_BYPASS_CUSTOMER_BEGIN = 'POST_BYPASS_CUSTOMER_BEGIN'
export const POST_BYPASS_CUSTOMER_SUCCESS = 'POST_BYPASS_CUSTOMER_SUCCESS'
export const POST_BYPASS_CUSTOMER_FAILURE = 'POST_BYPASS_CUSTOMER_FAILURE'

export const DELETE_BYPASS_CUSTOMER_BEGIN = 'DELETE_BYPASS_CUSTOMER_BEGIN'
export const DELETE_BYPASS_CUSTOMER_SUCCESS = 'DELETE_BYPASS_CUSTOMER_SUCCESS'
export const DELETE_BYPASS_CUSTOMER_FAILURE = 'DELETE_BYPASS_CUSTOMER_FAILURE'

export const CLEAN_BYPASS_CUSTOMER = 'CLEAN_BYPASS_CUSTOMER'

// Company Form Actions
export const POST_COMPANY_FORM_BEGIN = 'POST_COMPANY_FORM_BEGIN'
export const POST_COMPANY_FORM_SUCCESS = 'POST_COMPANY_FORM_SUCCESS'
export const POST_COMPANY_FORM_FAILURE = 'POST_COMPANY_FORM_FAILURE'

export const GET_CATEGORIES_BEGIN = 'GET_CATEGORIES_BEGIN'
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS'
export const GET_CATEGORIES_FAILURE = 'GET_CATEGORIES_FAILURE'

// Company Credit Policy Actions
export const GET_ALL_CREDIT_POLICIES_BEGIN = 'GET_ALL_CREDIT_POLICIES_BEGIN'
export const GET_ALL_CREDIT_POLICIES_SUCCESS = 'GET_ALL_CREDIT_POLICIES_SUCCESS'
export const GET_ALL_CREDIT_POLICIES_FAILURE = 'GET_ALL_CREDIT_POLICIES_FAILURE'

export const GET_CREDIT_POLICY_BEGIN = 'GET_CREDIT_POLICY_BEGIN'
export const GET_CREDIT_POLICY_SUCCESS = 'GET_CREDIT_POLICY_SUCCESS'
export const GET_CREDIT_POLICY_FAILURE = 'GET_CREDIT_POLICY_FAILURE'

export const POST_CREDIT_POLICY_BEGIN = 'POST_CREDIT_POLICY_BEGIN'
export const POST_CREDIT_POLICY_SUCCESS = 'POST_CREDIT_POLICY_SUCCESS'
export const POST_CREDIT_POLICY_FAILURE = 'POST_CREDIT_POLICY_FAILURE'

export const PUT_CREDIT_POLICY_BEGIN = 'PUT_CREDIT_POLICY_BEGIN'
export const PUT_CREDIT_POLICY_SUCCESS = 'PUT_CREDIT_POLICY_SUCCESS'
export const PUT_CREDIT_POLICY_FAILURE = 'PUT_CREDIT_POLICY_FAILURE'

export const ACTIVATE_CREDIT_POLICY_BEGIN = 'ACTIVATE_CREDIT_POLICY_BEGIN'
export const ACTIVATE_CREDIT_POLICY_SUCCESS = 'ACTIVATE_CREDIT_POLICY_SUCCESS'
export const ACTIVATE_CREDIT_POLICY_FAILURE = 'ACTIVATE_CREDIT_POLICY_FAILURE'

export const DELETE_CREDIT_POLICY_BEGIN = 'DELETE_CREDIT_POLICY_BEGIN'
export const DELETE_CREDIT_POLICY_SUCCESS = 'DELETE_CREDIT_POLICY_SUCCESS'
export const DELETE_CREDIT_POLICY_FAILURE = 'DELETE_CREDIT_POLICY_FAILURE'

// Plan Group Actions
export const GET_PLAN_GROUP_BEGIN = 'GET_PLAN_GROUP_BEGIN'
export const GET_PLAN_GROUP_SUCCESS = 'GET_PLAN_GROUP_SUCCESS'
export const GET_PLAN_GROUP_FAILURE = 'GET_PLAN_GROUP_FAILURE'

export const GET_USAGE_LOG_BEGIN = 'GET_USAGE_LOG_BEGIN'
export const GET_USAGE_LOG_SUCCESS = 'GET_USAGE_LOG_SUCCESS'
export const GET_USAGE_LOG_FAILURE = 'GET_USAGE_LOG_FAILURE'

// Dashboard Actions
export const GET_SCORE_METRICS_BEGIN = 'GET_SCORE_METRICS_BEGIN'
export const GET_SCORE_METRICS_SUCCESS = 'GET_SCORE_METRICS_SUCCESS'
export const GET_SCORE_METRICS_FAILURE = 'GET_SCORE_METRICS_FAILURE'

export const GET_UNIQUE_DOCUMENTS_BEGIN = 'GET_UNIQUE_DOCUMENTS_BEGIN'
export const GET_UNIQUE_DOCUMENTS_SUCCESS = 'GET_UNIQUE_DOCUMENTS_SUCCESS'
export const GET_UNIQUE_DOCUMENTS_FAILURE = 'GET_UNIQUE_DOCUMENTS_FAILURE'

export const GET_SCORE_BY_DOCUMENT_BEGIN = 'GET_SCORE_BY_DOCUMENT_BEGIN'
export const GET_SCORE_BY_DOCUMENT_SUCCESS = 'GET_SCORE_BY_DOCUMENT_SUCCESS'
export const GET_SCORE_BY_DOCUMENT_FAILURE = 'GET_SCORE_BY_DOCUMENT_FAILURE'

export const GET_LOGS_BY_DOCUMENT_BEGIN = 'GET_LOGS_BY_DOCUMENT_BEGIN'
export const GET_LOGS_BY_DOCUMENT_SUCCESS = 'GET_LOGS_BY_DOCUMENT_SUCCESS'
export const GET_LOGS_BY_DOCUMENT_FAILURE = 'GET_LOGS_BY_DOCUMENT_FAILURE'

export const CLEAN_SCORE_METRICS = 'CLEAN_SCORE_METRICS'
export const CLEAN_USAGE_LOG_METRICS = 'CLEAN_USAGE_LOG_METRICS'
export const CLEAN_USAGE_LOG_BY_DOCUMENT = 'CLEAN_USAGE_LOG_BY_DOCUMENT'

export const GET_SCORE_METRICS_BY_DATE_BEGIN = 'GET_SCORE_METRICS_BY_DATE_BEGIN'
export const GET_SCORE_METRICS_BY_DATE_SUCCESS = 'GET_SCORE_METRICS_BY_DATE_SUCCESS'
export const GET_SCORE_METRICS_BY_DATE_FAILURE = 'GET_SCORE_METRICS_BY_DATE_FAILURE'

// Company Customers Actions
export const GET_COMPANY_CUSTOMER_BEGIN = 'GET_COMPANY_CUSTOMER_BEGIN'
export const GET_COMPANY_CUSTOMER_SUCCESS = 'GET_COMPANY_CUSTOMER_BYCCESS'
export const GET_COMPANY_CUSTOMER_FAILURE = 'GET_COMPANY_CUSTOMER_BYILURE'

export const GET_COMPANY_CUSTOMERS_BEGIN = 'GET_COMPANY_CUSTOMERS_BEGIN'
export const GET_COMPANY_CUSTOMERS_SUCCESS = 'GET_COMPANY_CUSTOMERS_SUCCESS'
export const GET_COMPANY_CUSTOMERS_FAILURE = 'GET_COMPANY_CUSTOMERS_FAILURE'

export const SET_COMPANY_CUSTOMER_QUERY = 'SET_COMPANY_CUSTOMER_QUERY'

// Batch File Actions
export const SET_BATCH_FILES_TABLE_PAGINATION = 'SET_BATCH_FILES_TABLE_PAGINATION'

export const GET_ALL_BATCH_FILES_BEGIN = 'GET_ALL_BATCH_FILES_BEGIN'
export const GET_ALL_BATCH_FILES_SUCCESS = 'GET_ALL_BATCH_FILES_SUCCESS'
export const GET_ALL_BATCH_FILES_FAILURE = 'GET_ALL_BATCH_FILES_FAILURE'

export const UPLOAD_BATCH_FILE_BEGIN = 'UPLOAD_BATCH_FILE_BEGIN'
export const UPLOAD_BATCH_FILE_SUCCESS = 'UPLOAD_BATCH_FILE_SUCCESS'
export const UPLOAD_BATCH_FILE_FAILURE = 'UPLOAD_BATCH_FILE_FAILURE'

export const DOWNLOAD_BATCH_FILE_BEGIN = 'DOWNLOAD_BATCH_FILE_BEGIN'
export const DOWNLOAD_BATCH_FILE_SUCCESS = 'DOWNLOAD_BATCH_FILE_SUCCESS'
export const DOWNLOAD_BATCH_FILE_FAILURE = 'DOWNLOAD_BATCH_FILE_FAILURE'
